import type { ReactElement } from "react";

/**
 * The single top-bar Download call to action, shared by SC2's Preset download and a simple Game's
 * source download. It is the bar's one solid (ember) control: a download glyph, the constant word
 * "Download", and a mono chip naming the artifact. The word never changes across games; only the
 * chip swaps. Two element shapes: an anchor for a byte-faithful vendored asset (an href the browser
 * saves verbatim) and a button for a file built in the browser at click time.
 */
export function DownloadButton(
  props:
    | { format: string; href: string; fileName: string }
    | { format: string; onClick: () => void },
): ReactElement {
  const body = (
    <>
      {/* download glyph: an arrow into a tray */}
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 3v12" />
        <path d="M7 11l5 5 5-5" />
        <path d="M5 21h14" />
      </svg>
      Download
      <span className="fmt-chip">{props.format}</span>
    </>
  );
  if ("href" in props) {
    return (
      <a
        className="preset-download"
        href={props.href}
        download={props.fileName}
        title="Download this profile"
      >
        {body}
      </a>
    );
  }
  return (
    <button
      type="button"
      className="preset-download"
      onClick={props.onClick}
      title="Download this profile"
    >
      {body}
    </button>
  );
}
